var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAttempts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 18C0 8.05888 8.05888 0 18 0C27.9411 0 36 8.05888 36 18C36 27.9411 27.9411 36 18 36C8.05888 36 0 27.9411 0 18Z",
    fill: "#FFF7ED"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_137_78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5534 11.4533C18.3797 11.3741 18.191 11.3331 18.0001 11.3331C17.8091 11.3331 17.6204 11.3741 17.4467 11.4533L11.7334 14.0533C11.6151 14.1055 11.5145 14.1909 11.4439 14.2992C11.3733 14.4075 11.3357 14.534 11.3357 14.6633C11.3357 14.7926 11.3733 14.9191 11.4439 15.0274C11.5145 15.1357 11.6151 15.2212 11.7334 15.2733L17.4534 17.88C17.6271 17.9592 17.8158 18.0002 18.0067 18.0002C18.1977 18.0002 18.3863 17.9592 18.5601 17.88L24.2801 15.28C24.3984 15.2278 24.4989 15.1424 24.5695 15.0341C24.6402 14.9258 24.6778 14.7993 24.6778 14.67C24.6778 14.5407 24.6402 14.4142 24.5695 14.3059C24.4989 14.1976 24.3984 14.1122 24.2801 14.06L18.5534 11.4533Z",
    stroke: "#F54900",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3334 18C11.3331 18.1275 11.3693 18.2524 11.4379 18.36C11.5064 18.4675 11.6043 18.5531 11.72 18.6067L17.4534 21.2133C17.6262 21.2916 17.8137 21.3321 18.0034 21.3321C18.1931 21.3321 18.3806 21.2916 18.5534 21.2133L24.2734 18.6133C24.3914 18.5603 24.4914 18.4741 24.5612 18.3652C24.6311 18.2562 24.6677 18.1294 24.6667 18",
    stroke: "#F54900",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3334 21.3333C11.3331 21.4609 11.3693 21.5858 11.4379 21.6933C11.5064 21.8008 11.6043 21.8865 11.72 21.94L17.4534 24.5467C17.6262 24.6249 17.8137 24.6654 18.0034 24.6654C18.1931 24.6654 18.3806 24.6249 18.5534 24.5467L24.2734 21.9467C24.3914 21.8936 24.4914 21.8074 24.5612 21.6985C24.6311 21.5896 24.6677 21.4627 24.6667 21.3333",
    stroke: "#F54900",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_137_78"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAttempts);
export default __webpack_public_path__ + "static/media/ic_attempts.a72785cef76e9ba13dc72718a8b611dc.svg";
export { ForwardRef as ReactComponent };